import React from 'react';
import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../../../constants';

type PhoneNumberWithCountryProps = {
  country: string;
  phoneNumber: string;
};

const PhoneNumberWithCountry: React.FC<PhoneNumberWithCountryProps> = ({
  country,
  phoneNumber,
}) => {
  return (
    <Container>
      <CountryName>{country}</CountryName>
      <PhoneNumberText>{phoneNumber}</PhoneNumberText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px 0;
  @media screen and ${device.sm} {
    gap: 20px;
  }
`;

const CountryName = styled.span`
  color: ${COLORS.FOOTER_TEXT_COLOR};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  min-width: 118px;
  text-align: left;
  font-family: ${FONTS.SUBTITLE};
  @media screen and ${device.lg} {
    min-width: 80px;
  }
`;

const PhoneNumberText = styled.h6`
  color: ${COLORS.WHITE};
  margin: 0;
  font-family: ${FONTS.SUBTITLE};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

export default PhoneNumberWithCountry;

PhoneNumberWithCountry.displayName = 'PhoneNumberWithCountry';
